<!-- Copyright (c) 2009-2022. Authors: see NOTICE file.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.-->

<template>
<svg
  xmlns:dc="http://purl.org/dc/elements/1.1/"
  xmlns:cc="http://creativecommons.org/ns#"
  xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  xmlns:svg="http://www.w3.org/2000/svg"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
  xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
  width="4mm"
  height="4mm"
  viewBox="0 0 14.173228 14.173229"
  id="svg2"
  version="1.1"
  inkscape:version="0.91 r13725"
  sodipodi:docname="free-polygon.svg"
>
  <defs id="defs4" />
  <sodipodi:namedview
    id="base"
    pagecolor="#ffffff"
    bordercolor="#666666"
    borderopacity="1.0"
    inkscape:pageopacity="0.0"
    inkscape:pageshadow="2"
    inkscape:zoom="52.572505"
    inkscape:cx="9.7957273"
    inkscape:cy="6.9348154"
    inkscape:document-units="px"
    inkscape:current-layer="layer1"
    showgrid="false"
    inkscape:window-width="1855"
    inkscape:window-height="1056"
    inkscape:window-x="65"
    inkscape:window-y="24"
    inkscape:window-maximized="1"
    fit-margin-top="0"
    fit-margin-left="0"
    fit-margin-right="0"
    fit-margin-bottom="0"
  />
  <metadata id="metadata7">
    <rdf:RDF>
      <cc:Work rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title />
      </cc:Work>
    </rdf:RDF>
  </metadata>
  <g
    inkscape:label="Layer 1"
    inkscape:groupmode="layer"
    id="layer1"
    transform="translate(-27.016003,-31.914518)"
  >
    <path
      style="fill:none;fill-rule:evenodd;stroke-width:1.30416775;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
      stroke="currentColor"
      d="m 38.949622,43.986228 c 1.403938,-1.500316 -3.266544,-2.492688 0.146877,-5.771595 2.156977,-2.071976 -2.231271,-4.068703 -4.032879,-3.734999 -1.435084,0.265814 0.161219,2.123932 -1.933719,3.928337 -2.094933,1.804405 -4.714354,-0.508566 -4.747541,2.161303 -0.03833,3.084086 9.163323,4.917269 10.567262,3.416954 z"
      id="path4186"
      inkscape:connector-curvature="0"
      sodipodi:nodetypes="zsazsz"
    />
  </g>
</svg>
</template>

<script>
export default {
  name: 'icon-polygon-free-hand'
};
</script>
